import React from 'react';
import Lottie from "lottie-react";
import loadingAnimation from "./../../lottie/loading-animation.json";
import styled from 'styled-components';

const LoaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    background-color: black;
    background-image: url(/images/particles@2x.png);
    background-size: 100%;
    background-position: center;

    svg{
        max-width: 300px;
    }
`;

const HenigLoader = ({ open }) => {

    return (
        open ? 
            <LoaderWrapper>
                <Lottie
                    animationData={loadingAnimation}
                    loop={true}
                    autoplay={true}
                />
            </LoaderWrapper>
        : ''
    );
}

export default HenigLoader;